<template>
    <v-container>
        <v-dialog v-model="show" width="80%" heigth="80vh" id="balloon-container" @input="close">

            <div id="myModal" class="modal-2" @click="close()">
                <!--<v-card-actions>
                    <v-btn density="compact" @click="close()">Cerrar</v-btn>
                </v-card-actions>-->
                <div class="modal-content-2 bcard-body">
                    <div class="birthdayCard">
                        <div class="cardFront">
                            <div class="front-text">
                                <h3 class="happy">FELIZ</h3>
                                <br />
                                <h2 class="bday">CUMPLEAÑOS</h2>
                            </div>
                            <div class="wrap-deco">
                                <div class="decorations"></div>
                                <div class="decorationsTwo"></div>
                            </div>
                            <div class="wrap-decoTwo">
                                <div class="decorations"></div>
                                <div class="decorationsThree"></div>
                            </div>
                            <div class="plate">
                                <div class="cake"></div>
                                <div class="flame"></div>
                            </div>
                        </div>

                        <div class="cardInside">
                            <div class="inside-text">
                                <br />
                                <h3 class="happy">HAPPY</h3>
                                <br />
                                <h2 class="bday">BIRTHDAY</h2>
                                <br />
                                <h3 class="toyou">to you!</h3>
                            </div>
                            <div class="wishes">
                                <p class="dear-text">QUERID@ {{ datacumple }},</p>
                                <p class="wishes-text">¡El equipo de ausa no puede estar más feliz de poder compartir
                                    estos momentos contigo,  ¡te deseamos un maravilloso cumpleaños!</p>
                                <p class="name-text">Atte: GRUPO AUSA</p>
                            </div>
                        </div>
                    </div>
                </div>





            </div>
        </v-dialog>


        <v-card v-if="showCumpleaneros">
            <!--para el listado de los que cumplen años hoy-->
            <div id="balloon-container2"></div>

            <div class="row-center" style="margin-bottom: 10px">
                <div class="panel panel-body"
                    style="background-color: #FFFCED; background-image: url(https://www.pngall.com/wp-content/uploads/5/Birthday-Decoration-PNG-High-Quality-Image.png); background-position-y: -100px;  height: auto;">
                    <div id="confettis">
                        <div class="confetti" v-for="n in 20" v-bind:key="n"></div>
                    </div>

                    <div style="padding-top: 20px">
                        <p class="text-center pushed-on-small"
                            style="font-weight: 700; font-size: 40px; font-family: 'Anton'; color: #52283b; "> HOY ES
                            CUMPLEAÑOS DE</p>

                    </div>

                    <div class="row-center">
                        <v-row align="center" justify="center" style="margin-left: 10px; margin-right: 10px;">
                            <v-col cols="12" md="3" lg="3" sm="6" xl="2" v-for="(item) in cumpleaneros" justify="center"
                                v-if="item.uslogin != uslogin" v-bind:key="item.uslogin">
                                <center>
                                    <div class="flip-card">
                                        <div class="flip-card-inner">
                                            <div class="flip-card-front"
                                                style="padding-top:30px; padding-left: 20px; padding-right: 20px;">
                                                <p style="font-size: 22px; font-family: 'Anton'; font-weight: 900; color: #52283b "
                                                    class="text-left"> {{ item.usnom }} </p>
                                            </div>
                                            <div class="flip-card-back " style="padding:20px">
                                                <p
                                                    style="font-size: 14px; font-weight: 700; font-family: 'Anton', sans-serif;">
                                                    {{ item.info }} </p>
                                                <p> {{ item.extension }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </center>
                            </v-col>

                            <div style="margin-bottom: 20px;"> </div>
                        </v-row>
                    </div>
                </div>
            </div>
        </v-card>


        <!-- próximos cumpleaños -->
        <div class=" dark:bg-gray-900 mt-4 " style="background-repeat: no-repeat;
            background-position-x: right; background-position-y: bottom; background-size: 15%; padding: auto;">
            <h1 class="mb-4 text-xl font-bold text-center mb-4 text-gray-800 px-2"
                style="font-weight: 700; font-size: 25px;">Próximos cumpleaños...</h1>

            <div class="flex flex-container" style="">
                <div class="flip-card-PC  flex-grow " v-for="(cumple) in proximosCumples" v-bind:key="cumple.uslogin">
                    <div class="flip-card-inner bg-white">
                        <div class="flip-card-front-PC" style="padding: 15px 20px 5px 20px;">
                            <p style="font-size: 14px;  font-weight: 600; " class="text-left text-gray-600"> {{
                                cumple.usnom }} </p>
                            <p class="text-md text-gray-400 dark:text-gray-400 text-left align-baseline"
                                style="position: absolute; bottom: 0px;">{{ cumple.info_dias }}</p>
                        </div>
                        <div class="flip-card-back bg-white text-gray-700" style="padding:20px">
                            <p style="font-size: 16px; font-weight: 700; font-family: 'Anton', sans-serif;">
                                {{ cumple.info }} </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-container>

</template>

<script>
import '@/components/pages/main/cumpleaños/css/cumple.css';
import Cumple from "@/services/Cumple/cumple.service.js";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
export default {
    name: "birthdayMain",
    data() {
        return {
            show: false,
            showCumpleaneros: false,
            cumpleaneros: [],
            datacumple: '',
            uslogin: '',
            proximosCumples: []
        };
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
    },
    methods: {
        close() {
            this.show = false;
            const balloonContainer = document.getElementById("balloon-container");
            balloonContainer.remove();
        },
        random(num) {
            return Math.floor(Math.random() * num);
        },

        getRandomStyles() {
            var r = this.random(255);
            var g = this.random(255);
            var b = this.random(255);
            var mt = this.random(200);
            var ml = this.random(50);
            var dur = this.random(5) + 5;
            return `
                                      background-color: rgba(${r},${g},${b},0.7);
                                      color: rgba(${r},${g},${b},0.7);
                                      box-shadow: inset -7px -3px 10px rgba(${r - 10},${g - 10},${b - 10},0.7);
                                      margin: ${mt}px 0 0 ${ml}px;
                                      animation: float ${dur}s ease-in infinite
                                      `;
        },

        createBalloons(num) {

            if (this.show) {
                const balloonContainer = document.getElementById("balloon-container");
                for (var i = num; i > 0; i--) {
                    var balloon = document.createElement("div");
                    balloon.className = "balloon";
                    balloon.style.cssText = this.getRandomStyles();
                    balloonContainer.append(balloon);

                }
            }

        },

        removeBalloons() {
            const balloonContainer = document.getElementById("balloon-container");
            balloonContainer.style.opacity = 0;
            setTimeout(() => {
                balloonContainer.remove()
            }, 500)
        },
        async ObtenerProximosCumples() {
            const response = await Cumple.obtenerProximosCumples();
            if (response) this.proximosCumples = response
        }
    },
    async mounted() {
        await Cumple.usuarioLogeado(this).then(response => {
            this.uslogin = response;

        });

        await Cumple.usuariosCumple(this).then(response => {

            if (response.length > 0) {
                this.showCumpleaneros = true;
                this.cumpleaneros = response;
            }
            if (response.length == 1) {
                if (response[0].uslogin == this.uslogin) {
                    this.showCumpleaneros = false;
                }
            }
        });

        if (this.cumpleaneros.length > 0) {

            for (var i = 0; i < this.cumpleaneros.length; i++) {

                if (this.cumpleaneros[i].uslogin == this.uslogin) {
                    this.show = true;
                    this.datacumple = this.cumpleaneros[i].usnom;
                    setTimeout(() => {
                        this.createBalloons(50);
                        var modal = document.getElementById("myModal");
                        modal.style.display = "block";
                    }, 1000);
                }
            }

        }

        await this.ObtenerProximosCumples();
    }
};
</script>

<style scoped>
.bithday-container-card-style {
    background-color: firebrick;
}
</style>

<style>
@import url('https://fonts.googleapis.com/css2?family=Caveat:wght@600&family=Cormorant+Garamond:wght@700&display=swap');

/*body {
        margin: 0;
    }*/
.prueba {
    height: 100vh;
}

#balloon-container {
    height: 100%;
    padding: 1em;
    box-sizing: border-box;
    position: absolute;
    z-index: 9;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    transition: opacity 500ms;
}

#balloon-container2 {
    height: 100%;
    padding: 1em;
    box-sizing: border-box;
    position: absolute;
    z-index: 9;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    transition: opacity 500ms;
}

.balloon {
    height: 125px;
    width: 105px;
    border-radius: 75% 75% 70% 70%;
    position: relative;
}

.balloon:before {
    content: "";
    height: 75px;
    width: 1px;
    padding: 1px;
    background-color: #FDFD96;
    display: block;
    position: absolute;
    top: 125px;
    left: 0;
    right: 0;
    margin: auto;
}

.balloon:after {
    content: "▲";
    text-align: center;
    display: block;
    position: absolute;
    color: inherit;
    top: 120px;
    left: 0;
    right: 0;
    margin: auto;
}

@keyframes float {
    from {
        transform: translateY(10vh);
        opacity: 1;
    }

    to {
        transform: translateY(-300vh);
        opacity: 0;
    }
}

.modal-2 {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 20;
    /* Sit on top */
    padding-top: 100px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.12)
        /* Black w/ opacity */
}

/* Modal Content */
.modal-content-2 {
    background-color: transparent;
    margin: auto;
    padding: 20px;
    width: 80%;
}

/* The Close Button */
.close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

@media screen and (min-width: 480px) {

    .pushed-on-small {
        margin-top: 10px !important;
    }

    .birthdayCard {
        position: relative;
        width: 450px !important;
        height: 550px !important;
        cursor: pointer;
        transform-style: preserve-3d;
        transform: perspective(2500px);
        transition: 4s;
    }

    .front-text {
        margin-top: 100px !important;
    }

    .birthdayCard:hover {
        transform: perspective(2500px) rotate(5deg);
        box-shadow: inset 100px 20px 100px rgba(0, 0, 0, .15), 0 10px 100px rgba(0, 0, 0, 0.3);
    }

    .birthdayCard:hover .cardFront {
        transform: rotateY(-160deg);
    }

    .birthdayCard:hover .front-text {
        display: none;
    }

    .birthdayCard:hover .wrap-deco {
        display: none;
    }

    .birthdayCard:hover .wrap-decoTwo {
        display: none;
    }

    .birthdayCard:hover .plate {
        display: none;
    }

    .cardFront {
        position: relative;
        background-color: #fff;
        width: 450px !important;
        height: 550px !important;
        overflow: hidden;
        transform-origin: left;
        box-shadow: inset 100px 20px 100px rgba(0, 0, 0, .13), 30px 0 50px rgba(0, 0, 0, 0.1);
        transition: .4s;
    }

    .cardInside {
        position: absolute;
        background-color: #fff;
        width: 450px !important;
        height: 550px !important;
        z-index: -1;
        left: 0;
        top: 0;
        box-shadow: inset 100px 20px 100px rgba(0, 0, 0, 0.2);
    }

    .feliz-text .cumple-text .nombre-text {
        position: relative;
        font-family: 'Poor Richard';
        text-align: center;
        backface-visibility: hidden;
        font-size: 30px !important;
    }

    .happy,
    .toyou {
        position: relative;
        font-family: didot;
        text-align: center;
        backface-visibility: hidden;
        font-size: 80px !important;
    }

    .happy {
        top: 198px !important;
    }

    .toyou {
        top: 123px !important;
    }

    .bday {
        position: relative;
        font-family: arial;
        font-size: 35px !important;
        text-align: center;
        top: 163px !important;
    }

    .wrap-deco {
        position: absolute;
        top: -230px !important;
        left: -200px !important;
    }

    .wrap-decoB5 {
        position: absolute;
        top: -230px;
        right: -200px;
    }

    .decorations {
        position: absolute;
        width: 300px !important;
        height: 300px !important;
        border: 3px solid #333;
        border-radius: 50%;
    }

    .decorations:before,
    .decorations:after,
    .decorationsTwo:before,
    .decorationsTwo:after,
    .decorationsThree:before,
    .decorationsThree:after {
        content: "";
        position: absolute;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        width: 0;
        height: 0;
    }

    .decorations:before {
        border-top: 40px solid #f15bb5;
        top: 297px !important;
        left: 210px !important;
        transform: rotate(-5deg);
    }

    .decorations:after {
        border-top: 40px solid #f4d35e;
        top: 288px;
        left: 260px;
        transform: rotate(-17deg);
    }

    .decorationsTwo:before {
        border-top: 40px solid #00f5d4;
        top: 268px;
        left: 315px;
        transform: rotate(-30deg);
    }

    .decorationsTwo:after,
    .decorationsThree:after {
        border-top: 40px solid #9b5de5;
        top: 238px;
        left: 355px;
        transform: rotate(-40deg);
    }

    .wrap-decoTwo {
        transform: scaleX(-1);
        position: absolute;
        top: -230px;
        left: 445px;
    }

    .wrap-decoB2 {
        transform: scaleX(-1);
        position: absolute;
        top: -230px;
        right: 0px;
    }

    .decorationsThree:before {
        border-top: 40px solid #00bbf9;
        top: 268px;
        left: 315px;
        transform: rotate(-30deg);
    }

    .plate {
        position: absolute;
        width: 130px;
        height: 5px;
        background-color: #00bbf9;
        left: 160px !important;
        top: 233px !important;
    }

    .cake {
        position: absolute;
        overflow: hidden;
        width: 100px !important;
        height: 50px !important;
        background-color: #f15bb5;
        border-radius: 10px 10px 0 0;
        top: -50px;
        left: 15px;
        box-shadow: inset 0 -15px #f9c74f, inset 0 15px #432818;
    }

    .cake:before {
        content: "";
        position: absolute;
        background-color: #432818;
        width: 10px !important;
        height: 20px !important;
        top: 5px;
        border-radius: 20px;
        box-shadow: 10px 5px #f15bb5, 20px 0px #432818, 30px 2px #f15bb5, 40px 5px #432818, 50px 5px #f15bb5, 60px 0px #432818, 70px 5px #f15bb5, 80px 5px #432818, 90px 5px #f15bb5;
    }

    .plate:before {
        content: "";
        position: absolute;
        background: repeating-linear-gradient(-45deg, #9b5de5, #9b5de5 3px, #00f5d4 3px, #00f5d4 6px);
        width: 7px;
        height: 25px;
        top: -75px;
        left: 61px;
    }

    .plate:after {
        content: "";
        position: absolute;
        width: 1px;
        height: 5px;
        background-color: #333;
        top: -80px;
        left: 64px;
    }


    .flame {
        position: absolute;
        background-color: #fb5607;
        border-radius: 80% 0 55% 50% / 55% 0 80% 50%;
        transform: rotate(-45deg);
        width: 15px;
        height: 15px;
        opacity: 0.7;
        top: -93px;
        left: 57px;
    }

    .inside-text {
        position: relative;
        top: -160px;
        transform: scale(0.7);
    }

    .wishes {
        position: relative;
        top: -100px;
        margin: 25px;
    }

    .dear-text {
        font-family: 'Josefin Sans', sans-serif !important;
        font-size: 20px !important;
        color: #333;
    }

    .wishes-text {
        font-family: 'Sigmar', cursive;
        font-size: 25px !important;
    }


    .name-text {
        font-size: 16px !important;
        margin-left: 250px !important;
    }

    .cumple-card-container {
        margin-left: 15px !important;
        margin-right: 32px !important;
        margin-bottom: 30px !important;
    }
}

/*END OF MEDIA QUERY*/
.bcard-body {
    display: flex;
    align-items: center;
    justify-content: center;
}

.birthdayCard {
    position: relative;
    width: 250px;
    height: 350px;
    cursor: pointer;
    transform-style: preserve-3d;
    transform: perspective(2500px);
    transition: 4s;
}

.birthdayCard:hover {
    transform: perspective(2500px) rotate(5deg);
    box-shadow: inset 100px 20px 100px rgba(0, 0, 0, .15), 0 10px 100px rgba(0, 0, 0, 0.3);
}

.birthdayCard:hover .cardFront {
    transform: rotateY(-160deg);
}

.birthdayCard:hover .front-text {
    display: none;
}

.birthdayCard:hover .wrap-deco {
    display: none;
}

.birthdayCard:hover .wrap-decoTwo {
    display: none;
}

.birthdayCard:hover .plate {
    display: none;
}

.front-text {
    margin-top: 100px !important;
}


.cardFront {
    position: relative;
    background-color: #fff;
    width: 250px;
    height: 350px;
    overflow: hidden;
    transform-origin: left;
    box-shadow: inset 100px 20px 100px rgba(0, 0, 0, .13), 30px 0 50px rgba(0, 0, 0, 0.1);
    transition: .4s;
}

.cardInside {
    position: absolute;
    background-color: #fff;
    width: 250px;
    height: 350px;
    z-index: -1;
    left: 0;
    top: 0;
    box-shadow: inset 100px 20px 100px rgba(0, 0, 0, 0.2);
}

.feliz-text .cumple-text .nombre-text {
    position: relative;
    font-family: 'Poor Richard';
    text-align: center;
    backface-visibility: hidden;
    font-size: 30px;
}

.happy,
.toyou {
    position: relative;
    font-family: didot;
    text-align: center;
    backface-visibility: hidden;
    font-size: 35px;
}

.happy {
    top: 175px;
}

.toyou {
    top: 100px;
}

.bday {
    position: relative;
    font-family: arial;
    font-size: 30px;
    text-align: center;
    top: 139px;
}

.wrap-deco {
    position: absolute;
    top: -230px;
    left: -200px;
}

.wrap-decoB5 {
    position: absolute;
    top: -230px;
    right: -200px;
}

.decorations {
    position: absolute;
    width: 400px;
    height: 300px;
    border: 3px solid #333;
    border-radius: 50%;
}

.decorations:before,
.decorations:after,
.decorationsTwo:before,
.decorationsTwo:after,
.decorationsThree:before,
.decorationsThree:after {
    content: "";
    position: absolute;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    width: 0;
    height: 0;
}

.decorations:before {
    border-top: 40px solid #f15bb5;
    top: 297px;
    left: 210px;
    transform: rotate(-5deg);
}

.decorations:after {
    border-top: 40px solid #f4d35e;
    top: 288px;
    left: 260px;
    transform: rotate(-17deg);
}

.decorationsTwo:before {
    border-top: 40px solid #00f5d4;
    top: 268px;
    left: 315px;
    transform: rotate(-30deg);
}

.decorationsTwo:after,
.decorationsThree:after {
    border-top: 40px solid #9b5de5;
    top: 238px;
    left: 355px;
    transform: rotate(-40deg);
}

.wrap-decoTwo {
    transform: scaleX(-1);
    position: absolute;
    top: -230px;
    left: 445px;
}

.wrap-decoB2 {
    transform: scaleX(-1);
    position: absolute;
    top: -230px;
    right: 0px;
}

.decorationsThree:before {
    border-top: 40px solid #00bbf9;
    top: 268px;
    left: 315px;
    transform: rotate(-30deg);
}

.plate {
    position: absolute;
    width: 130px;
    height: 5px;
    background-color: #00bbf9;
    left: 60px;
    top: 200px;
}

.cake {
    position: absolute;
    overflow: hidden;
    width: 100px;
    height: 50px;
    background-color: #f15bb5;
    border-radius: 10px 10px 0 0;
    top: -50px;
    left: 15px;
    box-shadow: inset 0 -15px #f9c74f, inset 0 15px #432818;
}

.cake:before {
    content: "";
    position: absolute;
    background-color: #432818;
    width: 10px;
    height: 20px;
    top: 5px;
    border-radius: 20px;
    box-shadow: 10px 5px #f15bb5, 20px 0px #432818, 30px 2px #f15bb5, 40px 5px #432818, 50px 5px #f15bb5, 60px 0px #432818, 70px 5px #f15bb5, 80px 5px #432818, 90px 5px #f15bb5;
}

.plate:before {
    content: "";
    position: absolute;
    background: repeating-linear-gradient(-45deg, #9b5de5, #9b5de5 3px, #00f5d4 3px, #00f5d4 6px);
    width: 7px;
    height: 25px;
    top: -75px;
    left: 61px;
}

.plate:after {
    content: "";
    position: absolute;
    width: 1px;
    height: 5px;
    background-color: #333;
    top: -80px;
    left: 64px;
}


.flame {
    position: absolute;
    background-color: #fb5607;
    border-radius: 80% 0 55% 50% / 55% 0 80% 50%;
    transform: rotate(-45deg);
    width: 15px;
    height: 15px;
    opacity: 0.7;
    top: -93px;
    left: 57px;
}

.inside-text {
    position: relative;
    top: -160px;
    transform: scale(0.7);
}

.wishes {
    position: relative;
    top: -100px;
    margin: 25px;
}

.dear-text {
    font-family: 'Josefin Sans', sans-serif !important;
    font-size: 14px;
    color: #333;
}

.wishes-text {
    font-family: 'Sigmar', cursive;
    font-size: 15px;
}


.name-text {
    font-size: 14px;
    margin-left: 80px;
}

.cumple-card-container {
    margin-left: 15px;
    margin-right: 32px;
    margin-bottom: 30px;
}


.flip-card {
    background-color: transparent;
    width: 200px;
    height: 200px;
    perspective: 1000px;
    border-radius: 20px;
}

.flip-card-PC {
    background-color: transparent;
    width: 225px;
    margin: 4px 4px;
    height: 140px;
    perspective: 1000px;
    border-radius: 20px;
}



.flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.6s;
    transform-style: preserve-3d;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    border-radius: 20px;
}

.flip-card:hover .flip-card-inner,
.flip-card-PC:hover .flip-card-inner {
    transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back,
.flip-card-front-PC {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    border-radius: 20px;
}

.flip-card-front-PC {
    background-color: white;
}

.flip-card-front {
    background-color: #2980b9;
    background-image: url("https://www.ausa.com.mx/Imagenes/Blog/bdbg112.png");
    aspect-ratio: 1.2
}

.flip-card-back {
    background-color: #F9E2C7;
    color: #0C2566;
    transform: rotateY(180deg);
}

.flip-card-back:active {
    background-color: #ffff;
    box-shadow: 0 5px #666;
    transform: translateY(4px);
}


.pushed-on-small {
    margin-top: 90px;
}

.flex-container {
    display: flex;
    flex-wrap: wrap;
}

@media (min-width: 1024px) {
    .flex-container {
        flex-wrap: nowrap;
    }
}
</style>
